module.exports = __webpack_public_path__ + "static/media/칸타타프리미엄라떼175ml.9993968d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/snacks/칸타타프리미엄라떼175ml.png
// module id = 36
// module chunks = 0